import { Box, Flex, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SiestaStepCounterProps = {
  currentStep: number;
  totalSteps: number;
};

export function SiestaStepCounter({ currentStep, totalSteps }: SiestaStepCounterProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <Flex align="center" gap={3}>
      {steps.map(step => {
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;

        return (
          <Box
            key={step}
            h={20}
            miw={20}
            fw={FONT_WEIGHTS.bold}
            c="white"
            bg={'rgba(0,0,0,0.25)'}
            display="flex"
            px={isActive ? 'sm' : 0}
            opacity={isActive ? 1 : 0.5}
            style={{
              borderRadius: 999,
              alignItems: 'center',
              justifyContent: 'center',

              backdropFilter: 'blur(48px)',
              userSelect: 'none',

              transition: 'all 250ms ease',
            }}
          >
            {isCompleted ? (
              <IconCheck size={12} />
            ) : (
              <Text size="xs" fw={FONT_WEIGHTS.bold}>
                {step}
              </Text>
            )}
          </Box>
        );
      })}
    </Flex>
  );
}
